<template>
  <div v-if="hotbList.length">
    <div
      v-if="isTenant"
      class="hotb-section__header"
    >{{ $t('handoverTakeback') }}</div>
    <ul class="hotb-list">
      <li
        v-for="hotb in handoverList"
        :key="hotb.id"
        class="row"
      >
        <div class="hotb-info__type handover" />
        <div class="hotb-info">
          <a
            class="hotb-info__item-link"
            @click="navToDetail(hotb.id)"
          >{{ hotbDisplayName(hotb) }}</a>
          <div class="hotb-info__item-status">{{ trackStatus(hotb) }}</div>
        </div>
        <div class="hotb-info_item-date status">{{ dateUtil.formatDate(hotb.transactionDate) }}</div>
      </li>
    </ul>
    <ul class="hotb-list">
      <li
        v-for="hotb in takebackList"
        :key="hotb.id"
        class="row"
      >
        <div class="hotb-info__type takeback" />
        <div class="hotb-info">
          <a
            class="hotb-info__item-link"
            @click="navToDetail(hotb.id)"
          >{{ hotbDisplayName(hotb) }}</a>
          <div class="hotb-info__item-status">{{ trackStatus(hotb) }}</div>
        </div>
        <div class="hotb-info_item-date status">{{ dateUtil.formatDate(hotb.transactionDate) }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import dateUtil from '@/utils/dateUtil'
import { list } from '@/api/hotb/request'
import { hotbStatus } from '@/utils/locale'
import { mapGetters } from 'vuex'
import userHelper from '@/utils/userHelper'
import navigation from '@/utils/navigation'
import lodash from 'lodash'
import { getHotbPremises } from './utils'

export default {
  name: 'HotbList',
  props: {
    tenancyId: [String, Number],
  },

  data () {
    return {
      hotbList: [],
      dateUtil,
      deep,
    }
  },

  methods: {
    navToDetail (id) {
      if (this.isTenant) {
        navigation.toPage('tenantHandover', { id })
      } else if (this.isEngineer) {
        navigation.toPage('handover', { id })
      }
    },

    async getHotbs () {
      const tempHotbs = await list(`tenancyId=${this.tenancyId}`) || []
      this.hotbList = lodash.orderBy(tempHotbs, 'transactionDate')
    },
    hotbDisplayName (hotb) {
      const hotbType = this.$t(`tenancyProject.${lodash.toLower(hotb.type)}`)
      const of = this.$t('prepositions.of')
      const premises = getHotbPremises(hotb)
      return `${hotbType} ${of}${premises || this.$t('emptyValue')}`
    },
    trackStatus (hotb) {
      const approverName = userHelper.getUserName(deep(hotb, 'approver.username'), deep(hotb, 'approver.displayName'))
      const nowTime = new Date().getTime()
      const transactionDate = new Date(hotb.transactionDate).getTime()
      switch (hotb.status) {
        case hotbStatus.DRAFT:
          return this.$t('handover.notification.draft')
        case hotbStatus.WAPPR:
          return this.$t('handover.notification.isWaitingForAppr', [approverName])
        case hotbStatus.APPR:
          if (nowTime > transactionDate) {
            return this.$t('handover.notification.appr', [approverName])
          } else {
            return this.$t('handover.notification.pendingForArrange', [approverName])
          }
        case hotbStatus.REJECTED:
          return this.$t('handover.notification.rejected', [approverName])
        case hotbStatus.SCHEDULED:
          return this.$t('handover.notification.scheduledOn', [dateUtil.formatDate(hotb.scheduledTransactionDate, true)])
        case hotbStatus.UNSIGNED:
          return this.$t('handover.notification.unsigned')
        default: // Do nothing
      }
    },
  },
  computed: {
    ...mapGetters('user', ['isTenant', 'isEngineer']),
    handoverList () {
      const handoverList = []
      this.hotbList.map(item => {
        if (item.type === 'HANDOVER') {
          handoverList.push(item)
        }
      })
      return handoverList
    },
    takebackList () {
      const takebackbList = []
      this.hotbList.map(item => {
        if (item.type === 'TAKEBACK') {
          takebackbList.push(item)
        }
      })
      return takebackbList
    },
  },

  async mounted () {
    if (this.tenancyId) {
      await this.getHotbs()
    }
  },
  watch: {
    async tenancyId () {
      await this.getHotbs()
    },
  },
}
</script>

<style lang="scss" scoped>
.hotb-section__header {
  height: 48px;
  min-height: 48px;
  line-height: 48px;
  padding-left: 15px;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 4px 0 rgba(212, 212, 212, 0.5);
}
.hotb-list {
  float: left;
  padding: 15px;
  margin: 0;
  width: 50%;
  a {
    text-decoration: underline;
    word-wrap: break-word;
  }

  li:nth-child(odd) {
    margin-right: 20px;
  }
  li:nth-child(2n+1) {
    clear: left;
  }

  li {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #EDEDED;
    margin-bottom: 5px;
    position: relative;

    & .hotb-info__type {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 9px;
      margin-right: 17px;
      &.handover {
        background-color: #FAA91B;
      }
      &.takeback {
        background-color: #32698e;
      }
    }

    & .hotb-info {
      margin-left: 17px;
      padding-top: 12px;
      padding-bottom: 5px;
      margin-right: 40px;
      flex: 1;
    }

    & .hotb-info__item-link {
      font-size: 14px;
      color: #0c3a58;
      line-height: 1.43;
    }

    & .hotb-info__item-status {
      font-style: italic;
      line-height: 1.67;
      color: #888888;
      font-size: 12px;
    }

    & .hotb-info_item-date {
      font-weight: 14px;
      font-weight: bold;
      margin-right: 10px;
    }
  }

  li:nth-last-child(-n+2) {
    margin-bottom: 0;
  }
}
</style>
